<template>
  <!-- https://alligator.io/vuejs/vue-autocomplete-component/ -->
  <div class="autocomplete">
    <input
      :id="idval"
      ref="autocomplete"
      v-model="search"
      :placeholder="pholder"
      :aria-activedescendant="descendant"
      :disabled="disabled"
      type="text"
      autocomplete="off"
      aria-describedby="initInstr"
      aria-owns="autocomplete-results"
      aria-expanded="false"
      aria-autocomplete="both"
      @input="onChange"
      @keydown.down="onArrowDown"
      @keydown.up="onArrowUp"
      @keydown.enter="onEnter"
    >
    <ul
      v-show="isOpen"
      id="autocomplete-results"
      role="listbox"
      tabindex="0"
      class="autocomplete-results"
    >
      <li
        v-if="isLoading"
        class="loading"
      >
        Loading results...
      </li>
      <li
        v-for="(result, i) in results"
        v-else
        :id="'res-item' + i"
        :key="i"
        :aria-selected="i + 1 === arrowCounter ? true : false"
        :class="{ 'is-active dropdown_dropDownMenuItem--selected': i + 1 === arrowCounter }"
        role="option"
        class="autocomplete-result"
        @click="setResult(result.text)"
      >
        <span
          class="autocomplete-title"
        >
          {{ result.text }}
        </span>
        <span
          v-if="result.type !== 'Course'"
          class="autocomplete-category"
        >
          {{ result.type }}
        </span>
        <span
          class="sr-only"
        >
          Link to page
        </span>
      </li>
    </ul>
    <span
      id="initInstr"
      style="display: none;"
    >When autocomplete results are available use up and down arrows to review and enter to select.  Touch device users, explore by touch or with swipe gestures.</span>
  </div>
</template>

<script>
export default {
  name: 'Autocomplete',
  props: {
    items: {
      type: Array,
      required: false,
      default: () => []
    },
    idval: {
      type: String,
      required: false,
      default: ''
    },
    pholder: {
      type: String,
      required: false,
      default: ''
    },
    isAsync: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      isOpen: false,
      results: [],
      search: '',
      isLoading: false,
      arrowCounter: 0,
      descendant: ''
    }
  },
  watch: {
    items: function (val, oldValue) {
      // actually compare them
      if (val.length !== oldValue.length) {
        this.results = val
        this.isLoading = false
      }
    }
  },
  mounted () {
    document.addEventListener('click', this.handleClickOutside)
  },
  destroyed () {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    onChange () {
      console.log(this.search)
      // Let's warn the parent that a change was made

      // Is the data given by an outside ajax request?
      if (this.isAsync) {
        this.isLoading = true
      } else {
        // Let's  our flat array
        this.filterResults()
        this.isOpen = this.search !== ''
        this.arrowCounter = 0
        this.scrollToItem('res-item' + this.arrowCounter - 1) // reposition scroll to beginning of list
        this.$emit('searchVal', this.$refs.autocomplete.value)
      }
    },
    filterResults () {
      // first uncapitalize all the things
      this.results = this.items.filter((item) => {
        return item.text.toLowerCase().indexOf(this.search.toLowerCase()) > -1
      })
    },
    setResult (result) {
      this.search = result
      this.isOpen = false
      this.$emit('searchVal', this.search)
    },
    onArrowDown (evt) {
      if (this.arrowCounter < this.results.length) {
        this.arrowCounter = this.arrowCounter + 1
        this.descendant = 'res-item' + this.arrowCounter
        this.scrollToItem('res-item' + (this.arrowCounter - 1))
      }
    },
    onArrowUp () {
      // close box if user arrows up past first item
      if (this.arrowCounter > 1) {
        this.arrowCounter = this.arrowCounter - 1
        this.descendant = 'res-item' + this.arrowCounter
        this.scrollToItem('res-item' + (this.arrowCounter - 1))
      } else {
        this.isOpen = false
        this.arrowCounter = this.arrowCounter - 1
      }
    },
    onEnter () {
      this.isOpen = false
      if (this.results[this.arrowCounter - 1] !== undefined) {
        this.search = this.results[this.arrowCounter - 1].text
        // Check if user has arrowed onto list and send that result otherwise send partial
        if (this.arrowCounter > 0) {
          this.$emit('searchVal', this.search)
          this.arrowCounter = -1
        } else {
          this.$emit('searchVal', this.$refs.autocomplete.value)
        }
      }
    },
    handleClickOutside (evt) {
      if (!this.$el.contains(evt.target)) {
        this.isOpen = false
        this.arrowCounter = -1
      }
    },
    scrollToItem (idName) {
      // scroll the box of suggestions when the user uses the arrow keys
      const target = document.getElementById(idName)
      if (target) {
        target.parentNode.scrollTop = target.offsetTop
      }
    },
    reset () {
      this.search = ''
    }
  }
}
</script>

<style>
</style>
